<script setup lang="ts">
    import { STATUS_BESOK } from "@/tabs/Besok/utils";

    withDefaults(
        defineProps<{
            name?: string;
            multiple?: boolean;
            label?: string;
            ignoreEmptyData?: boolean;
        }>(),
        {
            name: "status",
            label: "Status",
        }
    );

    const getOptions = () => Object.values(STATUS_BESOK) ?? [];
</script>

<template>
    <KAutocomplete
        v-bind="$attrs"
        :name="name"
        :multiple="multiple"
        :options="getOptions"
        :label="label"
        :ignoreEmptyData="ignoreEmptyData"
    />
</template>
